<template>
  <div class="fccPublicacoes">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage
        :titlePage="
          controlePage.dstipopublicacaotipo == null ? titlePage : controlePage.dstipopublicacaotipo
        "
        v-if="permissaoPage"
      ></fccTitlePage>
      <div class="row">
        <div class="col-sm-6">
          <span class="titlePage"> {{ controlePage.spi }}</span>
        </div>
        <div class="col-sm-6 text-right">
          <span class="titlePage"> {{ titlePage }}</span>
        </div>
      </div>
      <hr v-if="controlePage.passoPublicacao !== 1" />
      <div class="row">
        <div class="col-sm-1 buttons" v-if="controlePage.passoPublicacao !== 1">
          <button
            @click="publicaHome"
            v-b-tooltip.hover
            title="Voltar Publicação"
            class="btn btn-light border shadow-sm ml-2 p-2 text-dark"
          >
            <font-awesome-icon icon="chevron-left" size="lg" fixed-width />
          </button>
        </div>
        <div
          class="col buttonsSelect"
          v-if="controlePage.passoPublicacao !== 1 && permissao != null"
        >
          <v-select
            :options="statusTipo"
            v-model="controlePage.idsituacao"
            placeholder="Selecione"
            label="dssituacao"
            :reduce="(situacao) => situacao.idsituacao"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!controlePage.idsituacao"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
        </div>
        <div class="col" v-if="controlePage.passoPublicacao !== 1 && permissao != null">
          <fcc-button
            class="mt-1 btn btn-light border shadow-sm ml-2 p-2 text-dark"
            @click="trocaSituacao()"
            >Atualizar</fcc-button
          >
        </div>
        <div :class="permissao != null ? 'col-sm-6 text-right' : 'col-sm-11 text-right'"></div>
      </div>

      <div class="row innerPage">
        <div class="col-sm-12">
          <fccEtapa01
            v-on:changePublicacao="changePublicacao"
            v-if="controlePage.passoPublicacao === 1"
          ></fccEtapa01>
        </div>
      </div>
      <div id="fInscricao">
        <div class="containerStep">
          <b-tabs
            class="fccTabsOriginal vertical"
            card
            vertical
            v-if="controlePage.passoPublicacao !== 1"
          >
            <b-tab title="Datas" @click="changeStep(2, 'Datas')">
              <h4 class="titlePage mb-3">Datas</h4>
              <template v-if="permissao != null">
                <fccEtapa02
                  :primeiroAcesso="primeiroAcesso"
                  @alteraPublicacao="alteraPublicacao"
                  v-if="controlePage.passoPublicacao === 2"
                  :idPublicacao="controlePage.idpublicacao"
                  :controlePage="controlePage"
                ></fccEtapa02>
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong> </template>
            </b-tab>
            <b-tab title="Configurações" @click="changeStep(3, 'Configurações')">
              <h3 class="titlePage">Configurações</h3>
              <template v-if="permissao != null">
                <fccEtapa03
                  v-if="controlePage.passoPublicacao === 3"
                  :idPublicacao="controlePage.idpublicacao"
                  :controlePage="controlePage"
                  @alteraPublicacao="alteraPublicacao"
                ></fccEtapa03>
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab title="Botões" @click="changeStep(17, 'Botões')">
              <template v-if="permissao != null">
                <h3 class="titlePage">Botões</h3>
                <FccBotoesPublicacao
                  :controlePage="controlePage"
                  v-if="controlePage.passoPublicacao === 17"
                />
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab title="Imagens" @click="changeStep(11, 'Imagens')">
              <template v-if="permissao != null">
                <fcc-imagens
                  @alteraPublicacao="alteraPublicacao"
                  v-if="controlePage.passoPublicacao === 11"
                  :idPublicacao="controlePage.idpublicacao"
                  :spi="controlePage.spi"
                  :controlePage="controlePage"
                />
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab
              title="Isenção e Redução"
              @click="changeStep(6, 'Isenção e Redução')"
              v-if="ativaIsencao"
              ><h3 class="titlePage mb-3">Isenção</h3>
              <template v-if="permissao != null">
                <FccSirs
                  v-if="controlePage.passoPublicacao === 6"
                  :idPublicacao="controlePage.idpublicacao"
                  :controlePage="controlePage"
              /></template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab
              title="Solicitações específicas"
              @click="changeStep(21, 'Solicitações específicas')"
              v-if="ativaIsencao"
              ><h3 class="titlePage mb-3">Solicitações específicas</h3>
              <template v-if="permissao != null">
                <FccSolicitacoesEspecificas
                  v-if="controlePage.passoPublicacao === 21"
                  :idPublicacao="controlePage.idpublicacao"
                  :controlePage="controlePage"
              /></template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab title="Prorroga boleto" @click="changeStep(22, 'Prorroga boleto')"
              ><template v-if="permissao != null">
                <FccProrrogaData
                  :controlePage="controlePage"
                  v-if="controlePage.passoPublicacao === 22"
                />
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab
              title="Boleto / GRU"
              @click="changeStep(4, 'Pagamento')"
              v-if="lstTipoPubicacao.possuipagamento"
              ><template v-if="permissao != null">
                <FccFiltraConta
                  :controlePage="controlePage"
                  @alteraPub="alteraPub"
                  v-if="controlePage.passoPublicacao == 4"
                />
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab title="Pix" @click="changeStep(14, 'Pix')"
              ><template v-if="permissao != null">
                <FccFiltraConta
                  :controlePage="controlePage"
                  @alteraPix="alteraPix"
                  :pix="true"
                  v-if="controlePage.passoPublicacao == 14"
                />
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab
              title="Campos"
              @click="changeStep(5, 'Campos')"
              v-if="lstTipoPubicacao.possuiformulario"
            >
              <template v-if="permissao != null">
                <FccForm
                  :headerToken="dadosLoginSession.fccTokenHeaders"
                  :controlePage="controlePage"
                  :spiPublicacao="controlePage.spi"
                  :idPublicacao="controlePage.idpublicacao"
                  v-if="controlePage.passoPublicacao === 5"
                  :chave-obrigatoria="lstTipoPubicacao.chaveobrigatoria" /></template
              ><template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab title="Cargos" @click="changeStep(20, 'Cargos')">
              <template v-if="permissao != null">
                <fcc-cargos
                  v-if="controlePage.passoPublicacao === 20"
                  :controlePage="controlePage"
                  :idPublicacao="controlePage.idpublicacao" /></template
              ><template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab
              title="Cidades"
              @click="changeStep(19, 'Cidades')"
              v-if="controlePage.qtdecidade > 0"
            >
              <template v-if="permissao != null">
                <FccCidades
                  v-if="controlePage.passoPublicacao === 19"
                  :controlePage="controlePage"
                  :idPublicacao="controlePage.idpublicacao"
                /> </template
              ><template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab title="Limpo" @click="changeStep(10, 'Limpo')" v-if="ativaIsencao"
              ><template
                ><FccMetadados
                  v-if="controlePage.passoPublicacao === 10"
                  :metaDados="controlePage"
                  :idPublicacao="controlePage.idpublicacao"
                ></FccMetadados>
              </template>
            </b-tab>
            <b-tab
              title="Tratamento das Inscrições"
              @click="changeStep(7, 'Tratamento das Inscrições')"
              v-if="ativaIsencao"
              ><template
                ><FccTratamentoInscricoes
                  v-if="controlePage.passoPublicacao === 7"
                  :idPublicacao="controlePage.idpublicacao"
                  :controlePage="controlePage"
                ></FccTratamentoInscricoes>
              </template>
            </b-tab>
            <b-tab
              title="Vagas Reservadas"
              @click="changeStep(8, 'Vagas Reservadas')"
              v-if="ativaIsencao"
              ><template
                ><FccVagasReservadas
                  v-if="controlePage.passoPublicacao === 8"
                  :idPublicacao="controlePage.idpublicacao"
                  :controlePage="controlePage"
                ></FccVagasReservadas>
              </template>
            </b-tab>
            <b-tab
              title="Correção Cadastral"
              @click="changeStep(9, 'Correção Cadastral')"
              v-if="ativaIsencao"
              ><template
                ><FccCorrecaoCadastral
                  v-if="controlePage.passoPublicacao === 9"
                  :idPublicacao="controlePage.idpublicacao"
                  :controlePage="controlePage"
                ></FccCorrecaoCadastral>
              </template>
            </b-tab>
            <b-tab
              title="Importação dos dados cadastrais"
              @click="changeStep(18, 'Importação dos dados cadastrais')"
            >
              <FccImportacaoDadosCadastrais
                v-if="controlePage.passoPublicacao === 18"
                :controlePage="controlePage"
              />
            </b-tab>
            <b-tab title="Gabaritos e Provas" @click="changeStep(13, 'Gabaritos e Provas')">
              <template
                ><FccGabaritosProvas
                  v-if="controlePage.passoPublicacao === 13"
                  :controlePage="controlePage"
                />
              </template>
            </b-tab>
            <b-tab title="Outras fases" @click="changeStep(12, 'Outras fases')" v-if="ativaIsencao"
              ><template v-if="permissao != null"
                ><FccOutraFases
                  v-if="controlePage.passoPublicacao === 12"
                  :baseUrlPublicacao="baseUrlPublicacao"
                  :controlePage="controlePage"
                ></FccOutraFases>
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab
              title="Testes"
              @click="changeStep(6, 'Testes')"
              v-if="lstTipoPubicacao.possuiformulario"
              ><template v-if="permissao != null">
                <FccUsuariosTestes
                  :lista-parametros="lstTipoPubicacao.listaparametros"
                  v-if="controlePage.passoPublicacao === 6"
                  v-on:listarTipoPublicacao="listarTipoPublicacao"
                  :controle-testes="controlePage"
                  :idPublicacaoTestes="controlePage.idpublicacao" /></template
              ><template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab title="Ferramentas" @click="changeStep(20, 'Ferramentas')">
              <template v-if="permissao != null">
                <FccFerramentas
                  v-if="controlePage.passoPublicacao === 20"
                  :controlePage="controlePage"
                />
              </template>
              <template v-else> Solicite permissão de visualização <strong>(V)</strong></template>
            </b-tab>
            <b-tab title="Analise de fotos" @click="changeStep(16, 'Analise de Fotos')">
              <fccAnaliseFotos
                :controlePage="controlePage.spi"
                v-if="controlePage.passoPublicacao === 16"
              />
            </b-tab>
            <b-tab title="Logs" @click="changeStep(15, 'Logs')">
              <FccLogs v-if="controlePage.passoPublicacao === 15" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './assets/sass/fccPublicacoes.scss'
import fccEtapa01 from './etapas/Etapa01.vue'
import fccEtapa02 from './etapas/Etapa02.vue'
import fccEtapa03 from './etapas/Etapa03.vue'
import FccFiltraConta from './fccContasBancarias/FccFiltraConta.vue'
import FccProrrogaData from './fccContasBancarias/FccProrrogaData.vue'
import FccUsuariosTestes from './etapas/ConfigTestes.vue'
import FccImagens from './etapas/FccImagens.vue'
import FccSirs from './etapas/Sir2.vue'
import FccTratamentoInscricoes from './fccTratamentoInscricoes/fccTratamentoInscricoes.vue'
import FccVagasReservadas from './fccVagasReservadas/fccVagasReservadas'
import FccCorrecaoCadastral from './fccCorrecaoCadastral/fccCorrecaoCadastral.vue'
import FccOutraFases from './fccOutrasFases/fccOutrasFases.vue'
import FccGabaritosProvas from './fccGabaritosProvas/fccGabaritosProvas.vue'
import fccAnaliseFotos from './fccAnaliseFotos/fccAnaliseFotos.vue'
import FccBotoesPublicacao from './fccBotoesPublicacao/FccBotoes'
import FccCidades from './fccCidades/fccCidades.vue'
import FccForm from 'pkgfe.fccform'
import FccCargos from './FccCargos/FccCargos.vue'
import axios from 'axios'
import store from '@/store'
import FccMetadados from './fccLimpo/fccMetadados.vue'
import FccLogs from './fccLogs/fccLogs.vue'
import candidato from './candidato.json'
import FccImportacaoDadosCadastrais from './fccImportacaoDadosCadastrais/fccImportacaoDadosCadastrais.vue'
import FccFerramentas from './fccFerramentas/fccFerramentas.vue'
import FccSolicitacoesEspecificas from './FccSolicitacoesEspecificas/FccSolicitacoesEspecificas.vue'

export default {
  data() {
    return {
      candidato,
      titlePage: 'Publicações',
      baseUrlPublicacao: '',
      permissao: null,
      statusTipo: [],
      ativaIsencao: true,
      lstTipoPubicacao: {
        possuiformulario: false,
        chaveobrigatoria: false,
        possuipagamento: false
      },
      controlePage: {
        passoPublicacao: 1,
        mostrarlinhadigitavel: true
      }
    }
  },
  components: {
    fccEtapa01,
    fccEtapa02,
    fccEtapa03,
    FccSirs,
    FccUsuariosTestes,
    FccFiltraConta,
    FccTratamentoInscricoes,
    FccForm,
    FccVagasReservadas,
    FccBotoesPublicacao,
    FccCorrecaoCadastral,
    FccMetadados,
    FccImagens,
    FccOutraFases,
    FccGabaritosProvas,
    FccLogs,
    fccAnaliseFotos,
    FccImportacaoDadosCadastrais,
    FccCidades,
    FccFerramentas,
    FccSolicitacoesEspecificas,
    FccCargos,
    FccProrrogaData
  },
  methods: {
    publicaHome() {
      this.titlePage = 'Publicações'
      this.controlePage = {
        passoPublicacao: 1
      }
    },
    listarTipoPublicacao() {
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoTipo/ListarPublicacaoTipoPorId/' +
            this.controlePage.idpublictipo +
            '/' +
            this.controlePage.idpublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstTipoPubicacao = response.data
        })
        .catch(this.setErrorSystem)
    },
    listarPublicacao() {
      axios
        .get(
          this.baseUrlPublicacao + 'PublicacaoSituacao/ListarPublicacaoSituacao',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.statusTipo = response.data
          this.carregaTexto('Carregando Permissões')
          setTimeout(() => {
            this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'V')
            this.carregaTexto()
          }, 1000)
        })
        .catch(this.setErrorSystem)
    },
    trocaSituacao() {
      this.callConfirm('Deseja realmente trocar a situação?', '').then((result) => {
        if (result.value) {
          axios
            .put(
              this.baseUrlPublicacao +
                'Publicacao/AlterarStatusPublicacao?idPublicacao=' +
                this.controlePage.idpublicacao +
                '&idSituacao=' +
                this.controlePage.idsituacao,
              {},
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              if (this.controlePage.idsituacao == 4) {
                this.gerarCdBoletoPublicacao(this.controlePage.idpublicacao).then(() => {
                  this.callToast(this.mensagensUpdate.adicionado)
                })
              }
              this.callToast(this.mensagensUpdate.editado, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    alteraPublicacao(controlePage) {
      this.carregaTexto(this.codeMensagem('C01'))
      let controleFinal = controlePage
      controleFinal.idcontabancaria =
        this.controlePage.contabancaria != null
          ? this.controlePage.contabancaria.idcontabancaria
          : 0
      controleFinal.idcontabancariapix =
        this.controlePage.contabancariapix != null
          ? this.controlePage.contabancariapix.idcontabancaria
          : 0
      controleFinal.dsPublicacao = ''
      axios
        .put(
          this.baseUrlPublicacao + 'Publicacao/AlterarPublicacao',
          controleFinal,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.$emit('changePublicacao', response.data)
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    alteraPix(id, conta) {
      if (id == 0) {
        this.controlePage.contabancariapix = null
      } else {
        this.controlePage.contabancariapix = conta
      }
    },
    alteraPub(id, conta, gru = false) {
      if (id == 0) {
        this.controlePage.contabancaria = null
        this.controlePage.gru = null
      } else {
        if (gru) {
          this.controlePage.gru = conta
          this.controlePage.contabancaria = null
        } else {
          this.controlePage.contabancaria = conta
          this.controlePage.gru = null
        }
      }
      this.$forceUpdate()
    },
    changeStep(step, title) {
      this.titlePage = title
      this.controlePage.passoPublicacao = step
    },
    changePublicacao(publicacao, status = false) {
      this.titlePage = 'Configurações da Publicação'
      this.controlePage = publicacao
      this.primeiroAcesso = status
      this.listarTipoPublicacao(publicacao.idpublictipo)
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarPublicacao()
  }
}
</script>
